import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NamedLink } from '../../components';

import css from './TabNav.module.css';
import ProfileIconCard from '../ProfileIconCard/ProfileIconCard';

const Tab = props => {
  const { className, id, disabled, text, selected, linkProps, editListingTab } = props;

  const linkClasses = classNames(css.link, {
    [css.selectedLink]: selected,
    [css.disabled]: disabled,
  });
  const editListingClasses = classNames(css.listingLink, {
    [css.selectedListingLink]: selected,
    [css.disabledListing]: disabled,
  });

  return (
    <div id={id} className={className}>
      <NamedLink className={editListingTab ? editListingClasses : linkClasses} {...linkProps}>
        {editListingTab&& !disabled && !selected && <span className={css.checkedIcon}><ProfileIconCard type="checked" /></span>}
        {text}
      </NamedLink>
    </div>
  );
};

Tab.defaultProps = { className: null, disabled: false, selected: false };

const { arrayOf, bool, node, object, string } = PropTypes;

Tab.propTypes = {
  id: string.isRequired,
  className: string,
  text: node.isRequired,
  disabled: bool,
  selected: bool,
  linkProps: object.isRequired,
};

const TabNav = props => {
  const { className, rootClassName, tabRootClassName, tabs, editListingTab } = props;
  
  const classes = classNames(rootClassName || css.root, className);
  const tabClasses = tabRootClassName || css.tab;
  return (
    <nav className={classes}>
      {tabs.map((tab, index) => {
        const id = typeof tab.id === 'string' ? tab.id : `${index}`;
        return <Tab key={id} id={id} className={tabClasses} {...tab} editListingTab={editListingTab} />;
      })}
    </nav>
  );
};

TabNav.defaultProps = {
  className: null,
  rootClassName: null,
  tabRootClassName: null,
  tabClassName: null,
};

TabNav.propTypes = {
  className: string,
  rootClassName: string,
  tabRootClassName: string,
  tabs: arrayOf(object).isRequired,
};

export default TabNav;
